import { useQuery } from "react-query"
import DataService from '../../config/DataServices'

const { getRequest} = DataService()


export const useGetReferral = ({page, size }) => {

    return useQuery({
        queryKey: ["get-referral" , page, size ],
        queryFn: () => {
            return getRequest(`user/referral-history?page=${page}&size=${size}`)
        }
    })
}